<template>
    <div class="virtual-colleague">
        <div class="temp-tabs">
            <a
                v-for="route in virtualColleagueRoutes"
                :key="route.url"
                :href="route.url"
                :class="{
                    'temp-tabs__url': true,
                    'temp-tabs__url--active': $route.matched.some(({ name }) => name === route.name ?? null),
                }"
            >
                {{ route.label }}
            </a>
        </div>
        <router-view />
    </div>
</template>

<script setup lang="ts">
    import createLegacyUrl from '@/utils/legacyUrls';

    const virtualColleagueRoutes: Record<string, any>[] = [
        {
            label: 'Algemeen',
            url: createLegacyUrl('company/settings/virtual-colleague/general'),
        },
        {
            label: 'Leads aanmaken',
            url: createLegacyUrl('company/settings/virtual-colleague/triggered-referrals/list'),
        },
        {
            label: 'Fase & Status bijhouden',
            url: createLegacyUrl('company/settings/virtual-colleague/realworks_status_rules/list'),
        },
        {
            label: 'Actie ondernemen',
            url: createLegacyUrl('company/settings/virtual-colleague/triggered-actions/list'),
        },
        {
            label: 'Leads sluiten',
            url: createLegacyUrl('company/settings/virtual-colleague/auto_close'),
        },
        {
            label: 'A.I.',
            name: 'settings-virtual-colleague-ai',
        },
    ];
</script>

<style lang="scss" scoped>
.virtual-colleague {
    position: relative;
    width: 100%;

    .temp-tabs {
        display: flex;
        gap: size(xs);
        position: absolute;
        top: -63px;
        left: 50%;
        width: max-content;
        transform: translateX(-50%);
        padding: size(xs);
        background-color: #DEE1E6;
        border-radius: size(xs);

        &__url {
            position: relative;
            display: flex;
            padding: size(sm) size(md);
            border-radius: size(xs);
            color: color(gray-800);
            text-decoration: none;
            font-size: font-size(sm);
            transition: .1s background-color;
            cursor: pointer;

            &::after {
                position: absolute;
                content: '';
                bottom: 5px;
                left: 50%;
                right: 50%;
                height: 2px;
                background-color: #f6ad55;
                transition: left .2s, right .2s;
            }

            &--active,
            &:hover {
                background-color: color(brand-white);

                &::after {
                    left: 20px;
                    right: 20px;
                }
            }
        }
    }
}
</style>
